import { RECRUIT_SAVED_SEARCH_PLACEHOLDER } from './recruitSavedAdminShared';

type Props = {
  searchWord: string;
  onSearchWordChange: (value: string) => void;
  onSearch: () => void;
  onReset: () => void;
};

export default function RecruitSavedSearchBar({
  searchWord,
  onSearchWordChange,
  onSearch,
  onReset,
}: Props) {
  return (
    <div className="admin-board-manage__search">
      <input
        type="text"
        className="admin-board-manage__search-input"
        placeholder={RECRUIT_SAVED_SEARCH_PLACEHOLDER}
        value={searchWord}
        onChange={(e) => onSearchWordChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSearch();
        }}
      />
      <button type="button" className="admin-board-manage__search-btn" onClick={onSearch}>
        검색
      </button>
      <button
        type="button"
        className="admin-board-manage__search-btn admin-board-manage__search-btn--ghost"
        onClick={onReset}
      >
        초기화
      </button>
    </div>
  );
}
